export default __webpack_public_path__ + "static/media/dizbuzz-white-logo.a31aaa6f.svg";